
export default {
  name: "the-about-step",
  props: {
    title: {
      required: true,
      default: "",
    },
    description: {
      required: true,
      default: "",
    },
    layout: {
      required: false,
      type: String,
      default: "chain",
    },
    tempUser: {
      required: false,
      type: Object,
      default: null,
    },
    error: {
      required: false,
      type: String,
      default: "",
    },
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      mobileNumber: "",
      validated: false,
      rules: {
        required: (value) => !!value || "Dette feltet er obligatorisk.",
        name: (value) => {
          const pattern = /^[a-zA-Z\Wæøå]{2,}$/;
          return (
            pattern.test(value.trim()) ||
            "Navn kan ikke inneholde tall eller spesialtegn."
          );
        },
        mobile: (value) => {
          const pattern = /^[0-9]{8}$/;
          return pattern.test(value) || "Mobilnummer må være 8 siffer.";
        },
      },
    };
  },
  created() {
    if (this.tempUser != null) {
      this.firstName = this.tempUser?.firstName;
      this.lastName = this.tempUser?.lastName;
      this.mobileNumber = this.tempUser?.mobile;
      this.$emit("setValue", {
        mobile: this.mobileNumber,
        firstName: this.firstName,
        lastName: this.lastName,
      });
    }
  },
  methods: {
    onInput() {
      this.$emit("setValue", {
        mobile: this.mobileNumber,
        firstName: this.firstName,
        lastName: this.lastName,
      });
    },
    validate() {
      return this.validated;
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.nameInput.$refs.input.focus();
      });
    });
  },
};
